/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

require("./bootstrap");
//require('tabler-ui/dist/assets/js/dashboard.js');
//require('@fortawesome/fontawesome-pro/js/light.js');

import moment from "moment";
import daterangepicker from "daterangepicker";

import Cleave from "cleave.js";
require("cleave.js/dist/addons/cleave-phone.us");

var hideseek = require("hideseek");
var pagination = require("simplePagination.js/jquery.simplePagination.js");

window.moment = moment;
window.daterangepicker = daterangepicker;
window.hideseek = hideseek;
window.pagination = pagination;

$.extend($.expr[":"], {
    containsi: function (elem, i, match, array) {
        return (
            (elem.textContent || elem.innerText || "")
                .toLowerCase()
                .indexOf((match[3] || "").toLowerCase()) >= 0
        );
    },
});

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

$(function () {
    $('.has-conditionals input[type="radio"]').on("change", function () {
        var self = $(this);
        var container = $(self).parents(".has-conditionals");
        $(container).children(".conditional-field").hide();

        var conditional_field = $(self).data("conditional-field");

        if (conditional_field) {
            console.log(conditional_field);
            $("#" + conditional_field).show();
        }
    });

    $('.has-conditionals input[type="radio"]:checked').trigger("change");
    //if conditional is checked, trigger change

    $(".conditional-require").on("change", function () {
        var self = $(this);
        var checked = $(self).is(":checked");

        var elements = $(self).data("require");
        elements = elements.split(",");

        for (var i = 0; i < elements.length; i++) {
            var label = $("#" + elements[i]).siblings("label");
            if (checked) {
                $(label).find("small").css("display", "inline");
            } else {
                $(label).find("small").hide();
            }
        }
    });

    // $('.amount-field').keyup(function() {
    //     var amount = $(this).val();
    //     amount = amount.replace(',', '');
    //     if(amount == '') {
    //         amount = 0;
    //     } else {
    //         amount = parseFloat(amount);
    //     }
    //     amount = amount.toFixed(2);
    //     $('.total').html(amount);
    // });

    if ($(".amount-field").length > 0) {
        $(".amount-field").trigger("keyup");
    }

    $(".total-value").trigger("keyup");

    $('[name="transaction_type"]').change(function () {
        if ($(this).val() == "REFUND") {
            $(".charge-btn").removeClass("btn-success");
            $(".charge-btn").addClass("btn-danger");
            $(".charge-btn .verbiage").text("Refund");
        } else {
            $(".charge-btn").addClass("btn-success");
            $(".charge-btn").removeClass("btn-danger");
            $(".charge-btn .verbiage").text("Charge");
        }
    });

    $(".section-toggle").click(function () {
        var toggle_for = $(this).data("toggle-for");
        $('div[data-toggle-section="' + toggle_for + '"]').slideToggle();
        $(this).toggleClass("open");
    });

    $(function () {
        $(".section-toggle-container").each(function () {
            var section = $(this);
            var toggle_for = $(this).data("toggle-section");
            if ($(this).find(".is-invalid").length) {
                $('div[data-toggle-for="' + toggle_for + '"]').click();
            }
        });

        $(".section-toggle").each(function () {
            var default_state = $(this).data("default-state");
            if (default_state == "open") {
                $(this).click();
            }
        });
    });

    $(".cleave-cc")
        .toArray()
        .forEach(function (field) {
            new Cleave(field, {
                creditCard: true,
            });
        });

    $(".cleave-exp")
        .toArray()
        .forEach(function (field) {
            new Cleave(field, {
                date: true,
                datePattern: ["m", "y"],
            });
        });

    $(".cleave-cvv")
        .toArray()
        .forEach(function (field) {
            new Cleave(field, {
                blocks: [4],
                numericOnly: true,
            });
        });

    $(".cleave-currency")
        .toArray()
        .forEach(function (field) {
            new Cleave(field, {
                numeral: true,
                numeralThousandsGroupStyle: "thousand",
            });
        });

    $(".cleave-phone")
        .toArray()
        .forEach(function (field) {
            new Cleave(field, {
                phone: true,
                phoneRegionCode: "US",
            });
        });

    $("form.save-on-change").change(function () {
        setTimeout(() => {
            $(this).submit();
        }, 100);
    });

    $(".search").hideseek();

    $('[data-toggle="tooltip"]').tooltip();

    //are you sure message
    $("form.are-you-sure").submit(function (event) {
        var form = this;
        event.preventDefault();
        var msg = $(this).data("msg");

        var modal = $(
            ' \
            <div class="modal fade" id="confirm-delete" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"> \
                <div class="modal-dialog"> \
                    <div class="modal-content"> \
                        <div class="modal-header"> \
                            Are you sure? \
                        </div> \
                        <div class="modal-body"> \
                            ' +
                msg +
                ' \
                        </div> \
                        <div class="modal-footer"> \
                            <button type="button" class="btn btn-default btn-cancel" data-dismiss="modal">Cancel</button> \
                            <button class="btn btn-danger btn-ok">Yes</button> \
                        </div> \
                    </div> \
                </div> \
            </div> \
        '
        );

        $("body").append(modal);
        $("#confirm-delete").show();
        setTimeout(() => {
            $(modal).addClass("show");
        }, 250);

        $(modal)
            .find(".btn-cancel")
            .click(function () {
                //$('#confirm-delete').hide();
            });
        $(modal)
            .find(".btn-cancel")
            .click(function () {
                //$('#confirm-delete').hide();
                $(modal).removeClass("show");
                setTimeout(() => {
                    $("#confirm-delete").remove();
                }, 250);
                //$('#confirm-delete').remove();
            });
        $(modal)
            .find(".btn-ok")
            .click(function () {
                form.submit();
            });
    });

    $(".table-link-rows td:not(.actions)").click(function () {
        var href = $(this).parent().data("href");
        if (href) {
            window.location = href;
        }
    });

    //customer search
    var searchRequest = null;
    $("#customer-autosearch").on("keyup", function (event) {
        var searchQuery = $(this).val();
        if (searchRequest) {
            searchRequest.abort();
        }

        //console.log(searchQuery);

        if (searchQuery.length >= 3) {
            $("#results").html("");
            var terminalId = $(this).data("terminal");
            //console.log(terminalId);
            searchRequest = $.ajax({
                method: "post",
                dataType: "json",
                data: "auto=1&tid=" + terminalId + "&q=" + searchQuery,
                url: "/customer/search",
                success: function (result) {
                    //console.log(result);
                    for (var index = 0; index < result.length; index++) {
                        let customer = result[index];
                        let item = $(
                            '<div class="list-group-item" data-id="' +
                                customer.id +
                                '"> \
                            <div>' +
                                customer.first_name +
                                " " +
                                customer.last_name +
                                " \
                                <small><br>" +
                                customer.email +
                                " " +
                                customer.company +
                                '</small> \
                            </div> \
                            <div class="card-detail"> \
                                ' +
                                customer.icon +
                                " \
                                " +
                                customer.last_four +
                                "\
                            </div>\
                        </div>"
                        );
                        $(item).click(function () {
                            setCustomer(customer);
                        });
                        $("#results").append(item);
                    }
                },
            });
        }
    });

    //certification scripts
    $("button.run-script").on("click", function (event) {
        event.preventDefault();
        var button = $(this);
        $(button).hide();
        //console.log(terminalId);
        $.ajax({
            method: "post",
            dataType: "json",
            data: "test=" + $(this).data("test"),
            url: "/admin/certification-script/api",
            success: function (result) {
                var cardBody = $(button)
                    .parent()
                    .parent()
                    .parent()
                    .find(".card-body");
                $(cardBody).show();
                $(cardBody).find(".alert").html(result.msg);
            },
        });
    });

    //certification scripts
    $("form.run-script").on("submit", function (event) {
        event.preventDefault();
        //var formData = new FormData( this );
        var formData = $(this).serialize();
        //console.log(formData);
        //return true;
        var form = $(this);
        $(form).hide();
        $.ajax({
            method: "post",
            dataType: "json",
            data: formData,
            url: "/admin/certification-script/api",
            success: function (result) {
                var cardBody = $(form).parent().parent().find(".card-body");
                $(form).parent().hide();
                $(cardBody).show();
                $(cardBody).find(".alert").html(result.msg);
            },
        });
    });

    const theForm = document.querySelector("#create-transaction");
    if (theForm) {
        new TransactionForm(theForm);
    }
});

function setCustomer(customer) {
    //console.log(customer);
    window.location.href =
        "/vt/transaction/create?customer_id=" +
        customer.id +
        "&paymentMethod_id=" +
        customer.default_payment_method_id;
}

var showTransaction = function (transaction_id) {
    // console.log(transaction_id);
    var request = $.ajax({
        //'data':filters,
        dataType: "json",
        url: "/transactions/panel/" + transaction_id,
        success: function (response) {
            //console.log(response.query);
            //location.reload();
            //$('.merchant-center-table-<?php echo $table_id; ?> #table-container').html(response.table);
            $(".transaction-panel__body").html(response.html);
            $(".transaction-panel-modals").html(response.modals);
            $("#transaction-panel").addClass("open");
        },
    });
};

window.showTransaction = showTransaction;

var printDiv = function printDiv(divName) {
    var printContents = document.getElementById(divName).innerHTML;
    var originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
};

window.printDiv = printDiv;

window.customerCopy = () => {
    $("#address_first_name").val($("#first_name").val());
    $("#address_last_name").val($("#last_name").val());
    $("#address_company").val($("#company").val());
};

class TransactionForm {
    constructor(el) {
        this._el = el;
        this._form = el;
        this._submitButton = this._el.querySelector("button.charge-btn");
        this._breakDown = this._el.querySelector(".payment-breakdown");
        this._subTotalEl = this._el.querySelector(".js-subtotal");
        this._surchargeEl = this._el.querySelector(".js-surcharge");
        this._totalEl = this._el.querySelector(".js-total");

        this._totalInput = this._el.querySelector("input.amount-field");
        this._transactionType = Array.from(
            this._el.querySelectorAll('input[name="transaction_type"]')
        );
        this._ccInput = this._el.querySelector("input#credit_card_number");
        this._paymentMethodId = this._el.querySelector(
            "input[name='paymentMethod_id']"
        )
            ? this._el.querySelector("input[name='paymentMethod_id']").value
            : null;

        this._debounceTimer;
        this._controller;
        this._signal;

        this._totalInput.addEventListener("input", () => {
            this.preRecalculate();
        });

        this._transactionType.forEach((tti) => {
            tti.addEventListener("change", () => {
                this.preRecalculate();
            });
        });

        if (this._ccInput) {
            this._ccInput.addEventListener("input", () => {
                this.preRecalculate();
            });
        }

        if (this._totalInput.value != "") {
            this.preRecalculate();
        }

        this._billingAddressForm = this._el.querySelector(".billing-address");
        this._shippingAddressForm = this._el.querySelector(".shipping-address");
        this._cardAddressComponents = this._el.querySelector(
            ".card-address-components"
        );
        this._shortFormInput = this._el.querySelector("#short");
        this._isShortForm = this._shortFormInput.value === "1";
        this._toggleShortFormButton = this._el.querySelector(
            "#short-address-form-btn"
        );
        this._copyFromBillingBtn = this._el.querySelector("#copy-from-billing");

        this.updateAddressComponents();

        if (this._toggleShortFormButton) {
            this._toggleShortFormButton.addEventListener("click", (e) => {
                e.preventDefault();
                this._isShortForm = !this._isShortForm;
                this._shortFormInput.value = this._isShortForm ? "1" : "0";
                this.updateAddressComponents();
            });
        }

        if (this._copyFromBillingBtn) {
            this._copyFromBillingBtn.addEventListener("click", () => {
                const billingInputs = Array.from(
                    this._billingAddressForm.querySelectorAll("input, select")
                );
                const shippingInputs = Array.from(
                    this._shippingAddressForm.querySelectorAll("input, select")
                );
                billingInputs.map((input, index) => {
                    shippingInputs[index].value = input.value;
                });
            });
        }
    }

    updateAddressComponents() {
        if (this._paymentMethodId) return;

        if (this._isShortForm) {
            this._toggleShortFormButton.innerText =
                "Add Billing & Shipping Information";
            this.disableAddressComponents(this._billingAddressForm);
            this.disableAddressComponents(this._shippingAddressForm);
            this.handleEnablingCardAddressComponents();
        } else {
            this._toggleShortFormButton.innerText =
                "Hide Billing & Shipping Information";
            this.enableAddressComponents(this._billingAddressForm);
            this.enableAddressComponents(this._shippingAddressForm);
            this.handleDisablingCardAddressComponents();
        }
    }

    enableAddressComponents(el) {
        if (el) {
            el.classList.remove("hide");
            Array.from(
                el.querySelectorAll("input[required], select[required]")
            ).map((input) => {
                input.disabled = false;
            });
        }
    }

    disableAddressComponents(el) {
        if (el) {
            el.classList.add("hide");
            Array.from(
                el.querySelectorAll("input[required], select[required]")
            ).map((input) => {
                input.disabled = true;
            });
        }
    }

    handleDisablingCardAddressComponents() {
        const street =
            this._cardAddressComponents.querySelector(
                "#billing_street_1"
            ).value;
        const zip =
            this._cardAddressComponents.querySelector("#billing_zip").value;

        this._billingAddressForm.querySelector("#billing_street_1").value =
            street;
        this._billingAddressForm.querySelector("#billing_zip").value = zip;

        this.disableAddressComponents(this._cardAddressComponents);
    }

    handleEnablingCardAddressComponents() {
        this.enableAddressComponents(this._cardAddressComponents);

        const street =
            this._billingAddressForm.querySelector("#billing_street_1").value;
        const zip =
            this._billingAddressForm.querySelector("#billing_zip").value;

        this._cardAddressComponents.querySelector("#billing_street_1").value =
            street;
        this._cardAddressComponents.querySelector("#billing_zip").value = zip;

        this.enableAddressComponents(this._cardAddressComponents);
    }

    preRecalculate() {
        this._submitButton.disabled = true;

        const paymentMethodId = this._paymentMethodId;
        const totalInputValue = this._totalInput.value ?? null;
        const ccInputValueLength = this._ccInput
            ? this._ccInput.value.length
            : 0;

        if (paymentMethodId || (totalInputValue && ccInputValueLength >= 6)) {
            clearTimeout(this._debounceTimer);
            this._debounceTimer = setTimeout(() => {
                this.recalculate();
            }, 500);
        }
    }

    async recalculate() {
        // this function should only run from this.preRecaluclate();
        if (this._breakDown) {
            this._breakDown.classList.remove("opacity-100");
            this._breakDown.classList.add("opacity-50");
        }

        if (this._controller) {
            this._controller.abort();
        }

        const body = new FormData(this._form);

        try {
            this._controller = new AbortController();
            this._signal = this._controller.signal;
            const response = await fetch("/vt/transaction/calculate", {
                signal: this._signal,
                method: "POST",
                body: body,
            });
            const responseBody = await response.json();

            if (this._subTotalEl) {
                this._subTotalEl.innerText = responseBody.amount_formatted;
            }

            if (this._surchargeEl) {
                this._surchargeEl.innerText = responseBody.surcharge_formatted;
            }

            if (this._totalEl) {
                this._totalEl.innerText = responseBody.total_formatted;
            }

            if (this._breakDown) {
                if (responseBody.surcharge_applied) {
                    this._breakDown.style.display = "block";
                } else {
                    this._breakDown.style.display = "";
                }
            }

            this._submitButton.disabled = false;

            if (this._breakDown) {
                this._breakDown.classList.add("opacity-100");
                this._breakDown.classList.remove("opacity-50");
            }
        } catch (error) {
            console.warn("error", error);
        } finally {
            this._controller = undefined;
            this._signal = undefined;
        }
    }
}

async function setClipboard(text) {
    const type = "text/plain";
    const blob = new Blob([text], { type });
    const data = [new ClipboardItem({ [type]: blob })];
    await navigator.clipboard.write(data);
}

window.setClipboard = setClipboard;

window.addEventListener("notifyError", (event) => {
    Toastify({
        text: event.detail,
        duration: 3000,
        close: true,
        gravity: "top", // `top` or `bottom`
        position: "center", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
            border: "#b91c1c",
            background: "#b91c1c",
            color: "#ffffff",
            textAlign: "center",
        },
        onClick: function () {}, // Callback after click
    }).showToast();
});

window.addEventListener("notifySuccess", (event) => {
    Toastify({
        text: event.detail,
        duration: 3000,
        close: true,
        gravity: "top", // `top` or `bottom`
        position: "center", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
            border: "#166534",
            background: "#166534",
            color: "#ffffff",
            textAlign: "center",
        },
        onClick: function () {}, // Callback after click
    }).showToast();
});

function initializeTableLinks() {
    document
        .querySelectorAll(".table-link-livewire td:not(.actions)")
        .forEach((td) => {
            td.addEventListener("click", function () {
                const href = this.parentElement.dataset.href;
                if (href) {
                    window.location = href;
                }
            });
        });
}

// Initial setup
initializeTableLinks();

window.initializeTableLinks = initializeTableLinks;

document.addEventListener("refresh-table-links", () => {
    setTimeout(() => {
        initializeTableLinks();
    }, 500);
});

function initializeDatePicker() {
    $(".date-range").daterangepicker({
        autoApply: false,
        autoUpdateInput: false,
        ranges: {
            Today: [moment(), moment()],
            Yesterday: [
                moment().subtract(1, "days"),
                moment().subtract(1, "days"),
            ],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
            ],
        },
        alwaysShowCalendars: true,
        locale: {
            cancelLabel: "Clear",
        },
    });

    $(".date-range").on("apply.daterangepicker", function (ev, picker) {
        $(this).val(
            picker.startDate.format("MM/DD/YYYY") +
                " - " +
                picker.endDate.format("MM/DD/YYYY")
        );
        $(this)[0].dispatchEvent(new Event("input"));
    });

    $(".date-range").on("cancel.daterangepicker", function (ev, picker) {
        $(this).val("");
        console.log(window.Livewire.find("#selectedDateRange"));
        $(this)[0].dispatchEvent(new Event("input"));
    });
}

window.initializeDatePicker = initializeDatePicker;

window.addEventListener("openTab", (event) => {
    console.log(event.detail);
    window.open(event.detail.url, "_blank");
});
